var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getEnableWalkScore)?_c('div',[_vm._t("default"),_c('div',{staticClass:"walk-score"},[_c('app-walk-score',{attrs:{"wsId":_vm.wsId,"address":_vm.address}})],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }